// extracted by mini-css-extract-plugin
export var button = "_hi-2";
export var card = "_hi-0";
export var closeButtonContainer = "_hi-3";
export var iconContainer = "_hi-1";